import CountryUtil from "../uidispatcherapi/CountryUtil";
import { SessionStore as OriginalSessionStore } from "../uidispatcherapi/SessionStore";
import { Store } from "./Store";

// A small helper wrapper over the SessionStore from the UIDispatcher.

type SessionStoreState = {
    customerStore: string;
    customerId: string;
    customerTierLevel: string | null | undefined;
    country: string;
    locale: string;
    isMarioCountry: boolean;
    isCombiOrderCountry: boolean;
    loggedIn: boolean;
    selectedDeliveryAddress:
        | {
              [x: string]: any;
          }
        | undefined
        | null;
    cardholderNumber: string | undefined | null;
    isEmployee: boolean;
    employeeId: string | undefined | null;
    isMcrmCountry: boolean;
};

export function getCustomerTierLevel(): string | null | undefined {
    if (typeof OriginalSessionStore.getCustomerTierLevel === "function") {
        return OriginalSessionStore.getCustomerTierLevel();
    } else {
        return null;
    }
}

export enum CustomerTierLevel {
    Tier1 = "1",
    Tier2 = "2",
    Tier3 = "3",
    Tier4 = "4"
}
export function getCustomerTierEnum(): CustomerTierLevel | null | undefined {
    if (typeof OriginalSessionStore.getCustomerTierLevel === "function") {
        return OriginalSessionStore.getCustomerTierLevel() as CustomerTierLevel;
    } else {
        return null;
    }
}

export function isTier12Customer(): boolean {
    // FIXME: this doesn't work as intended when being logged in as employee & having a customer selected.
    //   In that case, getCustomerTierLevel() === undefined.
    const tier = getCustomerTierLevel();
    return tier === "1" || tier === "2";
}

export enum Role {
    Employee = "employee",
    Customer = "customer",
    Anonymous = "anonymous"
}

export function getRole(): Role {
    if (OriginalSessionStore.isEmployee()) {
        const roleDefaultSetting = !!CountryUtil.getOptionalConfig().defaultFilterOnlyCustomerAssortment;
        return roleDefaultSetting ? Role.Customer : Role.Employee;
    } else if (OriginalSessionStore.isCustomer()) {
        return Role.Customer;
    } else {
        return Role.Anonymous;
    }
}

class SessionStoreImpl extends Store {
    state: SessionStoreState;

    constructor() {
        super();
        this.listenTo(OriginalSessionStore, this.onSessionStoreTrigger);
        this.state = this.makeState();
    }

    makeState(): SessionStoreState {
        return {
            customerStore: OriginalSessionStore.getCustomerStore(),
            customerId: OriginalSessionStore.getCustomerId(),
            customerTierLevel: getCustomerTierLevel(),
            loggedIn: OriginalSessionStore.loggedIn(),
            selectedDeliveryAddress: OriginalSessionStore.getSelectedDeliveryAddress(),
            cardholderNumber: OriginalSessionStore.getCardholderNumber(),
            isEmployee: OriginalSessionStore.isEmployee(),
            employeeId: OriginalSessionStore.getEmployeeId(),
            // FIXME(FD) the below are completely static; you shouldn't use storeConnect just to get them
            country: OriginalSessionStore.getCountry(),
            locale: OriginalSessionStore.getLocale(),
            isMarioCountry: OriginalSessionStore.isMarioCountry(),
            isCombiOrderCountry: OriginalSessionStore.isCombiOrderCountry(),
            isMcrmCountry: OriginalSessionStore.isMcrmCountry()
        };
    }

    getInitialState(): SessionStoreState {
        return this.makeState();
    }

    onSessionStoreTrigger() {
        this.state = this.makeState();
        this.trigger();
    }

    getState(): SessionStoreState {
        return this.state;
    }
}

export const SessionStore = new SessionStoreImpl();

export default SessionStore;
